import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-upgrade-plan-modal',
  templateUrl: './upgrade-plan-modal.component.html',
  styleUrls: ['./upgrade-plan-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpgradePlanModalComponent {

}
